import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  DepartmentApiItem,
  DepartmentApiResponse,
} from "@/actions/ssr/settings/getDepartmentsSSR";

interface DepartmentState {
  items: DepartmentApiItem[];
  totalPages: number;
  currentPage: number;
  totalItems: number;
}

const initialState: DepartmentState = {
  items: [],
  totalPages: 1,
  currentPage: 1,
  totalItems: 0,
};

const departmentSlice = createSlice({
  name: "department",
  initialState,
  reducers: {
    setDepartmentItems(state, action: PayloadAction<DepartmentApiItem[]>) {
      state.items = action.payload;
    },
    setDepartmentPagination(
      state,
      action: PayloadAction<{
        totalPages: number;
        currentPage: number;
        totalItems?: number;
      }>,
    ) {
      state.totalPages = action.payload.totalPages;
      state.currentPage = action.payload.currentPage;
      if (action.payload.totalItems !== undefined) {
        state.totalItems = action.payload.totalItems;
      }
    },
    setDepartments(state, action: PayloadAction<DepartmentApiResponse>) {
      state.items = action.payload.results;
      state.totalPages = action.payload.total_pages;
      state.currentPage = action.payload.current_page;
      state.totalItems = action.payload.count;
    },
  },
});

export const { setDepartmentItems, setDepartmentPagination, setDepartments } =
  departmentSlice.actions;
export default departmentSlice.reducer;
